import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import FeedCardHeader from './FeedCardHeader';
import FeedCardFooter from './FeedCardFooter';
import FeedCardContent from './FeedCardContent';
import { useSelector } from 'react-redux';
import { checkUserToken } from '../../helpers/api/auth';

const FeedCard = ({ id, title, author, created_at, updated_at, description, files, className, dropPost }) => {
  const { token } = useSelector(state => state.auth.user);
  const [profile, setProfile] = useState({ data: false, isLoading: true, error: false });

  useEffect(() => {
    let isMounted = true;
    const ac = new AbortController();
    if (token) {
      const getProfile = async () => {
        try {
          const { data } = await checkUserToken(token);
          isMounted && setProfile((prev) => { return { ...prev, data: data, isLoading: false } });
        } catch (e) {
          isMounted && setProfile((prev) => { return { ...prev, error: e, isLoading: false } });
        }
      }
      getProfile();
    }
    return () => {
      ac.abort();
      isMounted = false;
    }
    // eslint-disable-next-line
  }, []);

  return <Card className={`${className && className}`}>
    <FeedCardHeader {...{ id, title, author, created_at, updated_at, dropPost }} />
    <FeedCardContent {...{ id, description, files, profile }} />
{/*     <FeedCardFooter {...{ id, author, profile }} /> */}
  </Card>
}

export default FeedCard;